import { render } from "./CarrouselComponent.vue?vue&type=template&id=c078a508&scoped=true"
import script from "./CarrouselComponent.vue?vue&type=script&lang=js"
export * from "./CarrouselComponent.vue?vue&type=script&lang=js"

import "./CarrouselComponent.vue?vue&type=style&index=0&id=c078a508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c078a508"]])

export default __exports__